import * as React from 'react';
import { cn, evaluateBooleanOrPredicate } from '../../../../utils';
import { MoreMenu } from '../../../atoms/icons';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '../../../molecules';
import type { ComplexTreeMoreOptionsProps } from '../types';

//TODO: unify this component with the data-grid's more options menu https://bond-sports.atlassian.net/browse/BOND-15042
export function ComplexTreeMoreOptions({ moreOptions, item, className, ariaLabel }: ComplexTreeMoreOptionsProps) {
	const allVisibleOptions = moreOptions.filter(option => evaluateBooleanOrPredicate(option.visible, item.data, true));

	if (!allVisibleOptions.length || !item.data) {
		return null;
	}

	return (
		<div className={cn('ml-auto', className)}>
			<DropdownMenu>
				<DropdownMenuTrigger
					className="flex h-[4.8rem] w-[2.4rem] items-center justify-center rounded-[0.4rem] hover:bg-bgPrimary focus:outline-hidden"
					aria-label={ariaLabel}
				>
					<MoreMenu aria-hidden="true" />
				</DropdownMenuTrigger>
				<DropdownMenuContent align="start" className="z-50 rounded-none border-none p-0">
					{allVisibleOptions.map(option => {
						const isDisabled = evaluateBooleanOrPredicate(option.disabled, item.data, false);
						return (
							<DropdownMenuItem
								key={option.label}
								disabled={isDisabled}
								onSelect={() => {
									option.onClick?.(item.data);
								}}
								className={cn(
									'block w-full px-4 py-2 text-left text-sm text-primary focus:outline-hidden',
									isDisabled ? 'cursor-not-allowed text-disabled' : 'hover:bg-bgPrimary'
								)}
							>
								{option.label}
							</DropdownMenuItem>
						);
					})}
				</DropdownMenuContent>
			</DropdownMenu>
		</div>
	);
}
